module.exports = __webpack_public_path__ + "img/bh_14.dbf84a91.jpg";